import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]',
})
export class OnlyNumbersDirective {
  private readonly _integerUnsignedRegex = '^[0-9]*$';
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private readonly _specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private readonly _el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this._specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    const current: string = this._el.nativeElement.value;
    // We need this because the current value on the DOM element
    // is not yet updated with the value from this event
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this._integerUnsignedRegex)) {
      event.preventDefault();
    }
  }
}
